import React from "react";
import { Box } from "@material-ui/core";
import { useSelector } from "react-redux";

import RAGIndicator from "components/visuals/RAGIndicator";

import { selectors } from "modules/customer/insights/performance/forecast/forecastRevenue";

const ForecastCompanySalesTrend = () => {
    const forecastCompanySalesTrend = useSelector(state => selectors.forecastCompanySalesTrend(state));
    const { loading, error, id, label, status, value } = forecastCompanySalesTrend;

    return (
        <Box data-cy={id}>
            <RAGIndicator loading={loading} error={error} label={label} status={status} value={value} />
        </Box>
    );
};

export default ForecastCompanySalesTrend;
